import styled from 'styled-components';
import {LARGE_TEXT_PX ,X_SMALL_TEXT_PX,DARK_NAVY_FONT_COLOR,PRIMARY_FONT_COLOR,FONT_FAMILY_DEMI,FONT_FAMILY_REGULAR, BASE_TEXT_PX} from 'src/styles/fonts/MCFontConstants';

export const QRCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 10px;
`;

export const QRCodeText = styled.span`
    font-family: ${FONT_FAMILY_DEMI};
    font-weight: 600;
    font-style: normal;
    font-size: ${LARGE_TEXT_PX};
    line-height: 100%;
    letter-spacing: 0%;
    color: ${DARK_NAVY_FONT_COLOR};
    margin-bottom: 12px;

`;

export const QRCodeTextRegular = styled.span`
    font-family: ${FONT_FAMILY_REGULAR};
    font-weight: 400;
    font-style: normal;
    font-size: ${BASE_TEXT_PX};
    line-height: 24px;
    letter-spacing: 0%;
    color: ${PRIMARY_FONT_COLOR};
    margin-bottom: 12px;
`;

export const QRCodeWrapper = styled.div`
    height: auto;
    max-width: 100%;
    width: 100%;
    border-radius: 6px;
    padding: 2px 40px;
    align-items: center;
    justify-content: center;
    display: flex;

    @media (max-width: 576px) {
        padding: 0;
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 7px;
`;
